import styled from "styled-components";
import closeIcon from "assets/icons/close_circle.svg";
import WarningIconTriangle from "icons/WarningIconTriangle";

const WithCloseWrapper = styled.div`
  padding: 8px;
  background: #fffae5;
  border-radius: 6px;
  font-weight: 450;
  font-size: 12px;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ color }) => (color ? color : "#865503")};
  gap: 8px;

  .contentBox {
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
  }

  img {
    margin-top: 2px;
  }

  @media screen and (max-width: 768px) {
    display: none;
    align-items: flex-start;
  }
`;

const Wrapper = styled.div`
  padding: 8px;
  background: #fffae5;
  border-radius: 6px;
  font-weight: 450;
  font-size: 12px;
  line-height: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  color: ${({ color }) => (color ? color : "#865503")};

  img {
    margin-top: 2px;
  }
`;

const Info = ({ content, withClose, close, color }) => {
  if (withClose) {
    return (
      <WithCloseWrapper color={color}>
        <div className="flexRow contentBox">
          <div>
            <WarningIconTriangle size={20} color={color ?? ""} />
          </div>
          <p>{content}</p>
        </div>

        <button onClick={close}>
          <img src={closeIcon} alt="warning" width="24px" height="24px" />
        </button>
      </WithCloseWrapper>
    );
  }

  return (
    <Wrapper color={color}>
      <div className="flexRow alignCenter">
        <WarningIconTriangle size={20} color={color ?? ""} />
      </div>
      <p>{content}</p>
    </Wrapper>
  );
};

export default Info;
